import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

import { Observable, BehaviorSubject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { urls as apis } from './apiUrls';
import { Council, Region } from '../models/SiteGroups';

import {
    HttpErrorHandler,
    HandleError,
} from './common/http-error-handler.service';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
    }),
};

@Injectable()
export class ListService {
    councilUrl = apis.councilListUrl;
    regionUrl = apis.regionListUrl;
    partnerUrl = apis.partnerGroupListUrl;
    siteTypeUrl = apis.siteTypesListUrl;

    private councils$: BehaviorSubject<Council[]> = new BehaviorSubject<
        Council[]
    >([]);
    private regions$: BehaviorSubject<Region[]> = new BehaviorSubject<Region[]>(
        []
    );
    private siteTypes$: BehaviorSubject<string[]> = new BehaviorSubject<
        string[]
    >([]);

    private handleError: HandleError;

    constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
        this.handleError = httpErrorHandler.createHandleError('ListService');
    }

    public getCouncilList(): Observable<Council[]> {
        if (this.councils$.getValue().length == 0) {
            return this.getApiCouncilList();
        }

        return this.councils$.asObservable();
    }

    public getRegionList(): Observable<Region[]> {
        if (this.regions$.getValue().length ===0) {
            return this.getApiRegionList();
        }
        return this.regions$;
    }


    public getSiteTypeList(): Observable<string[]> {
        if (this.siteTypes$.getValue().length == 0) {
            return this.getApiSiteTypeList();
        }
        return this.siteTypes$;
    }

	private getApiCouncilList(): Observable<Council[]> {
        return this.http.get(this.councilUrl, httpOptions).pipe(
            tap((data: any) => {
                this.councils$.next(data);
            }))
    }

    private getApiRegionList(): Observable<any> {
        return this.http
            .get(this.regionUrl, httpOptions)
            .pipe(            tap((data: any) => {
                this.regions$.next(data);
            }),catchError(this.handleError('getRegionList', {})));
    }

    private getApiSiteTypeList(): Observable<any> {
        return this.http
            .get(this.siteTypeUrl, httpOptions)
            .pipe(            tap((data: any) => {
                this.siteTypes$.next(data);
            }),catchError(this.handleError('getSiteTypeList', {})));
    }
}
